import pick from 'lodash/pick';
import omit from 'lodash/omit';
import size from 'lodash/size';

// Distractor targets removed altogether from the backend, so they are not accepted
// Instead of removing all frontend logic omitting it from the query payload.
const target_fields = ['primary_targets', 'secondary_targets']; // 'distractor_targets'];

const tasks_ignored_fields = ['context_audio'];
const items_ignored_fields = ['distractor_targets'];
const answers_ignored_fields = ['item_id', 'created_at', 'updated_at'];

export default function convertToUploadFormat(task) {
    task = omit(task, ...tasks_ignored_fields);

    if (task?.calibration_status === 'not_set') {
        task.calibration_status = 'uncalibrated';
    }

    return {
        ...task,

        items: task.items.map(item => {
            item = omit(item, ...items_ignored_fields);

            const targets = pick(item, ...target_fields);
            item = omit(item, ...target_fields);
            if (size(targets) > 0) {
                item.targets = targets;
            }

            if (item.answers)
                item.answers = item.answers.map((a) => omit(a, answers_ignored_fields));
            return item;
        }),

        // For tasks with final_audio_id, it must be null if empty
        ...('final_audio_id' in task && {
            final_audio_id: task.final_audio_id || null,
        }),
    };
}